import React from "react";
import "./SlotGamesPageStyle.scss";
import { slotGamesTextContent } from "./constant";
import MainLayout from "../../components/MainLayout";
import BannerSection from "../../components/BannerSection";
import ContactUsSection from "../../components/ContactUsSection";
import InsightSection from "../../components/InsightSection";
import GameDesignProcessSection from "../../components/GameDesignProcessSection";
import ArtDesignSection from "../../components/ArtDesignSection";
import AnimationsSection from "../../components/AnimationsSection";
import SoundsSection from "../../components/SoundsSection";
import DevelopmentSection from "../../components/DevelopmentSection";
import SlotGamesSection from "../../components/SlotGamesSection";
import AboutUsSection from "components/AboutUsSection";

const SlotGamesPage = () => {
  return (
    <MainLayout>
      <div className="slot-games-page">
        <BannerSection />
        {/* <InsightSection /> */}
        {/* <SlotGamesSection /> */}
        <GameDesignProcessSection />
        <ArtDesignSection />
        <AnimationsSection />
        <SoundsSection />
        <DevelopmentSection />
        <AboutUsSection />
        {/* <ContactUsSection /> */}
      </div>
    </MainLayout>
  );
};

export default SlotGamesPage;
